/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Topic_Full_SwingInputs */

const en_practice_topic_full_swing = /** @type {(inputs: Practice_Topic_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full Swing`)
};

const es_practice_topic_full_swing = /** @type {(inputs: Practice_Topic_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swing completo`)
};

const de_practice_topic_full_swing = /** @type {(inputs: Practice_Topic_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voller Schwung`)
};

const zh_practice_topic_full_swing = /** @type {(inputs: Practice_Topic_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全挥杆`)
};

const ar_practice_topic_full_swing = /** @type {(inputs: Practice_Topic_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`السوينغ الكامل`)
};

const fr_practice_topic_full_swing = /** @type {(inputs: Practice_Topic_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plein swing`)
};

const vi_practice_topic_full_swing = /** @type {(inputs: Practice_Topic_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swing đầy đủ`)
};

const sw_practice_topic_full_swing = /** @type {(inputs: Practice_Topic_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swing Kamili`)
};

const th_practice_topic_full_swing = /** @type {(inputs: Practice_Topic_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ฟูลสวิง`)
};

const bs_practice_topic_full_swing = /** @type {(inputs: Practice_Topic_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puni zamah`)
};

const ja_practice_topic_full_swing = /** @type {(inputs: Practice_Topic_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フルスイング`)
};

const ko_practice_topic_full_swing = /** @type {(inputs: Practice_Topic_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`풀스윙`)
};

const pt_practice_topic_full_swing = /** @type {(inputs: Practice_Topic_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swing completo`)
};

const it_practice_topic_full_swing = /** @type {(inputs: Practice_Topic_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swing completo`)
};

const sv_practice_topic_full_swing = /** @type {(inputs: Practice_Topic_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full sving`)
};

const nl_practice_topic_full_swing = /** @type {(inputs: Practice_Topic_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volledige swing`)
};

const da_practice_topic_full_swing = /** @type {(inputs: Practice_Topic_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuldt sving`)
};

const nb_practice_topic_full_swing = /** @type {(inputs: Practice_Topic_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full sving`)
};

const fi_practice_topic_full_swing = /** @type {(inputs: Practice_Topic_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Täysi swing`)
};

const pl_practice_topic_full_swing = /** @type {(inputs: Practice_Topic_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pełny swing`)
};

const ru_practice_topic_full_swing = /** @type {(inputs: Practice_Topic_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Полный свинг`)
};

const tr_practice_topic_full_swing = /** @type {(inputs: Practice_Topic_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tam swing`)
};

const hi_practice_topic_full_swing = /** @type {(inputs: Practice_Topic_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फुल स्विंग`)
};

const id_practice_topic_full_swing = /** @type {(inputs: Practice_Topic_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ayunan Penuh`)
};

const ms_practice_topic_full_swing = /** @type {(inputs: Practice_Topic_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hayunan Penuh`)
};

const cs_practice_topic_full_swing = /** @type {(inputs: Practice_Topic_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plný švih`)
};

const el_practice_topic_full_swing = /** @type {(inputs: Practice_Topic_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Πλήρες σβινγκ`)
};

const he_practice_topic_full_swing = /** @type {(inputs: Practice_Topic_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`סווינג מלא`)
};

const af_practice_topic_full_swing = /** @type {(inputs: Practice_Topic_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volle swaai`)
};

const hu_practice_topic_full_swing = /** @type {(inputs: Practice_Topic_Full_SwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teljes swing`)
};

/**
* | output |
* | --- |
* | "Full Swing" |
*
* @param {Practice_Topic_Full_SwingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const practice_topic_full_swing = /** @type {((inputs?: Practice_Topic_Full_SwingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Topic_Full_SwingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_practice_topic_full_swing(inputs)
	if (locale === "de") return de_practice_topic_full_swing(inputs)
	if (locale === "zh") return zh_practice_topic_full_swing(inputs)
	if (locale === "ar") return ar_practice_topic_full_swing(inputs)
	if (locale === "fr") return fr_practice_topic_full_swing(inputs)
	if (locale === "vi") return vi_practice_topic_full_swing(inputs)
	if (locale === "sw") return sw_practice_topic_full_swing(inputs)
	if (locale === "th") return th_practice_topic_full_swing(inputs)
	if (locale === "bs") return bs_practice_topic_full_swing(inputs)
	if (locale === "ja") return ja_practice_topic_full_swing(inputs)
	if (locale === "ko") return ko_practice_topic_full_swing(inputs)
	if (locale === "pt") return pt_practice_topic_full_swing(inputs)
	if (locale === "it") return it_practice_topic_full_swing(inputs)
	if (locale === "sv") return sv_practice_topic_full_swing(inputs)
	if (locale === "nl") return nl_practice_topic_full_swing(inputs)
	if (locale === "da") return da_practice_topic_full_swing(inputs)
	if (locale === "nb") return nb_practice_topic_full_swing(inputs)
	if (locale === "fi") return fi_practice_topic_full_swing(inputs)
	if (locale === "pl") return pl_practice_topic_full_swing(inputs)
	if (locale === "ru") return ru_practice_topic_full_swing(inputs)
	if (locale === "tr") return tr_practice_topic_full_swing(inputs)
	if (locale === "hi") return hi_practice_topic_full_swing(inputs)
	if (locale === "id") return id_practice_topic_full_swing(inputs)
	if (locale === "ms") return ms_practice_topic_full_swing(inputs)
	if (locale === "cs") return cs_practice_topic_full_swing(inputs)
	if (locale === "el") return el_practice_topic_full_swing(inputs)
	if (locale === "he") return he_practice_topic_full_swing(inputs)
	if (locale === "af") return af_practice_topic_full_swing(inputs)
	if (locale === "hu") return hu_practice_topic_full_swing(inputs)
	return en_practice_topic_full_swing(inputs)
});